import PropTypes from 'prop-types';

import { getPagePath, trans } from '@spotahome/soyuz/client';
import { Button } from '@spotahome/ui-library';
import { DSIcon } from '@spotahome/ui-library/base';

import './HiwStepContent.scss';

const HiwStepContent = ({ description, bulletPoints = [], cta = null }) => (
  <>
    <p className="hiw-step-content__description">{trans(description)}</p>

    {bulletPoints.length > 0 && (
      <div className="hiw-step-content__bullet-points">
        {bulletPoints.map(point => (
          <div key={point.titleKey} className="hiw-step-content__bullet-point">
            <DSIcon name={point.iconName} size="ml" />
            <div className="hiw-step-content__bullet-point__text">
              <h3 className="hiw-step-content__bullet-point__title">
                {trans(point.titleKey)}
              </h3>
              <p className="hiw-step-content__bullet-point__description">
                {trans(point.textKey)}
              </p>
            </div>
          </div>
        ))}
      </div>
    )}
    {cta && (
      <Button
        alt
        className="hiw-step-content__cta"
        href={getPagePath(cta.routeId)}
      >
        {trans(cta.textKey)}
      </Button>
    )}
  </>
);

HiwStepContent.propTypes = {
  description: PropTypes.string.isRequired,
  bulletPoints: PropTypes.arrayOf(
    PropTypes.shape({
      titleKey: PropTypes.string.isRequired,
      textKey: PropTypes.string.isRequired
    })
  ),
  cta: PropTypes.shape({
    textKey: PropTypes.string.isRequired,
    routeId: PropTypes.string.isRequired
  })
};

export default HiwStepContent;
